import {
    useMemo,
    type FC,
    useRef
} from "react";
import {
    Animated
} from "react-native";
import type ITimeSelectorHelperPresenceProps from "./type";
import {
    getSlideStyle,
    usePresence
} from "../../../../helpers/motion";

const TimeSelectorHelperPresence: FC<ITimeSelectorHelperPresenceProps> = ({
    customTheme,
    isVisible,
    children,
    offset
}) => {
    const {
        isReduceMotionEnabled,
        isRendered,
        progress
    } = usePresence({
        exitIntent: "collapse",
        enterIntent: "expand",
        customTheme,
        isVisible
    });

    const contentRef = useRef(children);

    const slideStyle = useMemo(() => getSlideStyle({
        isReduceMotionEnabled,
        progress,
        offset
    }), [
        isReduceMotionEnabled,
        progress,
        offset
    ]);

    if(isVisible) {
        contentRef.current = children;
    }

    if(!isRendered) {
        return null;
    }

    return <Animated.View
        style={slideStyle}
    >
        {contentRef.current}
    </Animated.View>;
};
export default TimeSelectorHelperPresence;
